<common-mojo-expandable-card
  [expandable]="expandable"
  (toggle)="toggleCard($event)"
  *ngIf="showCard; else talentPoolView"
>

  <ng-template-outlet *ngTemplateOutlet="candidatesAchievements">
  </ng-template-outlet>

</common-mojo-expandable-card>

<ng-template #talentPoolView>
  <mojo-expandible-card
    [expandable]="expandable"
    (toggle)="toggleCard($event)"
  >
    <ng-template-outlet *ngTemplateOutlet="candidatesAchievements">
    </ng-template-outlet>
  </mojo-expandible-card>
</ng-template>

<ng-template #candidatesAchievements>

  <div
    class="achievements-header"
    [ngClass]="{'font-size-talent-pool': !showCard}"
  >Achievements</div>
  <ul class="achievements-list">
    <li
      *ngFor="let achievement of displayedAchievements; trackBy: track"
      class="achievements-list-element"
      [ngClass]="{'font-size-talent-pool': !showCard}"
      [innerHtml]="achievement"
    >
    </li>
  </ul>

</ng-template>
